import type { CSSProperties, LinariaClassName } from '@linaria/core';
import { cx } from '@linaria/core';
import { memo } from 'react';
import "./Trending.linaria.module.css!=!./Trending?./Trending.linaria.module.css?css=H4sIAAAAAAAAA22LywqDMBQF9/5Hl4qx0NoI/ZUQTWKuxETNjY8G/71QsGDpcs6cyTj2TDWM6Jvrwis7Y+yCR1Bb2jiL0iJtpEU5VXvyOepT9qXIDbQ2BZS9/ykenhFcF5hNFOAHwzeqjFwPPW+MOD+6Yo4LCNSU5PnlkESEUE53VtorKeo/09MP3EblLKaLhFYjrZ0R1Z68AQtAg+LlAAAA"
const rootStyles = "atm_fc_1h6ojuz atm_h_1h6ojuz atm_9s_1txwivl atm_vy_1osqo2v atm_1duu8r7_8n312b";
interface TrendingBannerProps {
  text?: string;
  diffClassName?: LinariaClassName;
  diffStyle?: CSSProperties;
  className?: LinariaClassName;
  style?: CSSProperties;
  hideIcon?: boolean;
  diff: number;
}
const TrendingBanner = memo((props: TrendingBannerProps) => {
  const {
    text = 'viewers in last minute',
    diffClassName,
    diffStyle,
    className,
    hideIcon,
    style,
    diff
  } = props;
  return <div data-testid="Container__TrendingBanner" className={cx(rootStyles, className)} style={style}>
            {hideIcon ? '' : '🔥'}
            <span className={diffClassName} style={diffStyle}>
                +{diff}
            </span>
            {text}
        </div>;
});
export default TrendingBanner;
export { TrendingBanner };